import React from 'react';
import {
    DocumentLinesIcon
} from '../../../../../../../components/buttons/IconButtons';
import UserDeductionRenderAssignedSection from "./UserDeductionRenderAssignedSection";
import {STEPS_ADD_USER_DEDUCTION_POLICY} from "../../DeductionPolicy/Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Expanded row for the user deduction policy table.
 * Follows the ShiftAccess RenderDetails pattern: RenderDetails owns the
 * mb-5/mt-4 wrappers; RenderAssignedSection fetches and renders one section.
 * Each section uses AssignedSectionTitle for the icon+title header.
 */

const RenderDetails = ({ row }) => (
    <div className="shift-detail-lists">
        <div className="mb-5 mt-4">
            <UserDeductionRenderAssignedSection
                resource={STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.KEY}
                id={row.id}
                userId={row.userId}
                title={STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.TRANS}
                Icon={DocumentLinesIcon}
                tableNotInformationLegend={'you_have_not_excluded_any_deduction_policies_yet'}
            />
        </div>
        <div className="mb-5 mt-4">
            <UserDeductionRenderAssignedSection
                resource={STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.KEY}
                id={row.id}
                userId={row.userId}
                title={STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.TRANS}
                Icon={DocumentLinesIcon}
                tableNotInformationLegend={'you_have_not_excluded_any_deduction_policies_yet'}
            />
        </div>
    </div>
);

export default RenderDetails;
